import { FC } from 'react';

import './NoDocuments.scss';

const NoDocuments: FC = () => (
  <div className="empty-state">
    <svg
      className="empty-state__icon"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="8"
        y="4"
        width="32"
        height="40"
        rx="4"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M16 16h16M16 24h16M16 32h8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
    <p className="empty-state__text">No documents yet</p>
    <span className="empty-state__subtext">
      Documents added to this folder will appear here
    </span>
  </div>
);

export default NoDocuments;
